import { defaultStages } from "../Constant/defaultStages";

const initialState = {
    stages: defaultStages
};

export default function probabilityReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_PROBABILITY_STAGES":
            return { ...state, stages: action.payload };
        case "GET_PROBABILITY_STAGES":
            return state;

        default:
            return state;
    }
}
